<div id="messageContainer">
    <h1>{{ 'ERROR.WeAreSorry' | translate }}</h1>
    <h2>{{ 'ERROR.VideoCannotBePlayed' | translate }}</h2>
</div>
